
import { Component, Vue } from 'vue-property-decorator';
const { VUE_APP_LIMIT: LimitApi } = process.env;
const API = {
  product: `${LimitApi}/boss/setting/auth/product`,
};
const columns = [
  { title: '系统', key: 'system', scopedSlots: { customRender: 'system' } },
  { title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } },
]
@Component
export default class LimitIndex extends Vue {
  table_data: any = []

  handleAccount(e: any) {
    this.$router.push({path: '/limit/mangement-account', query: {
      id: e.id,
      name: e.name,
    }})
  }

  async init() {
    const { data } = await this.$axios.get(API.product);
    if(data.status === 200) {
      this.table_data = data.data
    }
  }

  created() {
    this.init();
  }

  get columns() {
    return columns;
  }
}
